import {Subscription} from "rxjs";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {environment} from "@numizmat/environments";
import {ImageViewerService} from "@numizmat/services/common";
import {PublicAdDetailResponse} from "@numizmat/services-models/core";
import {ImageComponent, ToggleAdLikeButtonComponent} from "@numizmat/components";
import {AdDetailStateService} from "@numizmat/services/core/ad-detail/ad-detail-state.service";

@Component({
    selector: 'nz-ad-carousel',
    imports: [
        ImageComponent,
        ToggleAdLikeButtonComponent
    ],
    templateUrl: './ad-carousel.component.html',
    styleUrl: './ad-carousel.component.scss'
})
export class AdCarouselComponent implements OnInit, OnDestroy {
  private imageViewerService: ImageViewerService = inject(ImageViewerService);
  private adDetailStateService: AdDetailStateService = inject(AdDetailStateService);

  private subs: Subscription = new Subscription();

  protected imageUrls: string[] = [];
  protected currentImageIndex: number = 0;
  protected adDetails!: PublicAdDetailResponse;

  public ngOnInit(): void {
    this.getAdDetails();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onLike(userAdLikeId: string): void {
    this.adDetailStateService.setPublicAdDetails({
      ...this.adDetails,
      likeCount: this.adDetails.likeCount + 1,
      userAdLikeId: userAdLikeId
    });
  }

  protected onDislike(): void {
    this.adDetailStateService.setPublicAdDetails({
      ...this.adDetails,
      likeCount: this.adDetails.likeCount - 1,
      userAdLikeId: undefined
    });
  }

  protected onSlideImage(direction: 'next' | 'prev'): void {
    if (direction === 'next') {
      this.currentImageIndex === this.imageUrls.length - 1
        ? this.currentImageIndex = 0
        : this.currentImageIndex++;
    } else {
      this.currentImageIndex === 0
        ? this.currentImageIndex = this.imageUrls.length - 1
        : this.currentImageIndex--;
    }
  }

  protected onPreviewImages(): void {
    this.imageViewerService.setImages(this.imageUrls, this.currentImageIndex);
  }

  private getAdDetails() {
    const subscription: Subscription = this.adDetailStateService.getPublicAdDetails().subscribe({
      next: (adDetails: PublicAdDetailResponse | undefined) => {
        if (!!adDetails) {
          this.adDetails = adDetails;
          this.imageUrls = this.adDetails.imageIds.map(x => `${environment.apiImageAdUrl}/additional/${this.adDetails.adId}/${x}`);
        }
      }
    });
    this.subs.add(subscription);
  }
}
